import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useRefreshBankIncomingSuggestions } from '@/hooks/react-query/useBankIncoming';
import type { BankIncomingScope } from '@/services/bankIncomingService';

interface RefreshSuggestionsButtonProps {
  scope: BankIncomingScope;
}

export function RefreshSuggestionsButton({
  scope,
}: RefreshSuggestionsButtonProps) {
  const refreshSuggestions = useRefreshBankIncomingSuggestions(scope);

  return (
    <Button
      variant="outline"
      disabled={refreshSuggestions.isPending}
      onClick={() => refreshSuggestions.mutate()}
    >
      <RefreshCw
        className={`h-4 w-4 mr-2 ${refreshSuggestions.isPending ? 'animate-spin' : ''}`}
      />
      Re-run suggestions
    </Button>
  );
}
